import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Contact.css";

const translations = {
  ES: {
    title: "Contacto",
    name: "Nombre",
    surname: "Apellidos",
    email: "Email",
    message: "¿Cómo podemos ayudarte?",
    placeholderEmail: "Ej. juanlopez@gmail.com",
    submit: "Enviar mensaje",
    success: "Mensaje enviado con éxito.",
    error: "Error al enviar el mensaje. Inténtalo de nuevo más tarde.",
  },
  CAT: {
    title: "Contacte",
    name: "Nom",
    surname: "Cognoms",
    email: "Correu electrònic",
    message: "Com et podem ajudar?",
    placeholderEmail: "Ex. joanperez@gmail.com",
    submit: "Enviar missatge",
    success: "Missatge enviat amb èxit.",
    error: "Error en enviar el missatge. Torna-ho a intentar més tard.",
  },
};

const Contact = ({ contactRef }) => {
  const { language } = useLanguage();
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    nombre: "",
    apellidos: "",
    email: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_l4bxmuu",
        "template_z7fjkxi",
        formRef.current,
        "AgY5DyUYaP5BBgYOV"
      )
      .then(() => {
        alert(translations[language].success);
        setFormData({ nombre: "", apellidos: "", email: "", mensaje: "" });
      })
      .catch(() => {
        alert(translations[language].error);
      });
  };

  return (
    <section ref={contactRef} id="contact-form" className="contact">
      <h2>{translations[language].title}</h2>
      <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
        <div className="form-left">
          {["name", "surname", "email"].map((field) => (
            <div className="input-group" key={field}>
              <label htmlFor={field}>{translations[language][field]}</label>
              <input
                type={field === "email" ? "email" : "text"}
                id={field}
                name={
                  field === "name"
                    ? "nombre"
                    : field === "surname"
                    ? "apellidos"
                    : field
                }
                placeholder={
                  translations[language][
                    field === "email" ? "placeholderEmail" : field
                  ]
                }
                value={
                  formData[
                    field === "name"
                      ? "nombre"
                      : field === "surname"
                      ? "apellidos"
                      : field
                  ]
                }
                onChange={handleChange}
                required
                aria-label={translations[language][field]}
              />
            </div>
          ))}
        </div>

        <div className="form-right">
          <label htmlFor="mensaje">{translations[language].message}</label>
          <textarea
            id="mensaje"
            name="mensaje"
            value={formData.mensaje}
            onChange={handleChange}
            required
            aria-label={translations[language].message}
          />
        </div>

        <button type="submit" className="btn">
          {translations[language].submit}
        </button>
      </form>
    </section>
  );
};

export default Contact;
